<template>
  <div>
    <el-dialog  top="5vh" title="选择PR" :visible.sync="dialogVisible" width="60%" class="dialog-style">
      <div class="search-box">
        <el-input v-model="queryParams.prNumber" placeholder="PR编码" size="small" clearable/>
        <el-input v-model="queryParams.prName" placeholder="PR名称" size="small" clearable/>
        <el-select v-model="queryParams.brandCode" placeholder="选择品牌" size="small" clearable>
          <el-option v-for="item in btmpBrandDTOList" :key="item.brandCode" :label="item.brandDisplayName" :value="item.brandCode">
          </el-option>
        </el-select>
          <el-button type="danger" size="small" @click="handleSearchUnconfiguredList()">搜索</el-button>
          <el-button type="info" size="small" @click="resetForm()">重置</el-button>
      </div>
      <el-table v-loading="tableLoading" :data="prList" :header-cell-style="{background:'#E8E8E8',color:'#4d4d4d'}" @row-click="clickChange_history" :row-key="prList.prNumber" >
        <el-table-column label="PR编码" prop="prNumber" align="center" />
        <el-table-column label="PR名称" prop="prName" align="center" />
        <el-table-column label="品牌" prop="brandName" align="center" />
        <el-table-column label="子品牌" prop="subBrandName" align="center" />
        <el-table-column label="选取" min-width="55" prop="subBrandName" align="center">
          <template slot-scope="scope">
            <i v-if="selectedPRNumberList.indexOf(scope.row.prNumber)!==-1" class="el-icon-check"></i>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background :total="total" layout="total, prev, pager, next" :current-page="queryParams.page"
          :page-size="queryParams.pageSize" @current-change="handleCurrentChange" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="redFont" @click="dialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="handleSelectPR()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import gameplanApi from "@/api/gameplan";
export default {
  data() {
    return {
      dialogVisible:false,
      loading:false,
      queryParams:{
        page: 1,
        pageSize: 10,
        prNumber:'',
        prName:'',
        brandCode:''
      },
      total:0,
      selectedPRNumberList:[],
      prList:[],
      btmpBrandDTOList:[],
      PRInfoList:[],
      themeId:'',
      initPrNumberList:[],
      tableLoading:false
    };
  },
  created() {
    this.getGameplanThemeUnconfiguredList()
    this.getGamepalnBrandquery()
  },
  methods: {
    show(prInfoList,initPrNumberList){
      this.themeId = this.$route.query.themeId
      this.initPrNumberList = initPrNumberList
      this.selectedPRNumberList = prInfoList.map(item=>{
        return item.prNumber
      })
      this.PRInfoList = prInfoList.map(item=>{
        const data = {
          brandName:item.brandName,
          subBrandName:item.subBrandName,
          prNumber:item.prNumber,
          prName:item.prName
        }
        return data
      })
      this.getGameplanThemeUnconfiguredList()
      this.dialogVisible = true
    },
    handleSearchUnconfiguredList(){
      this.queryParams.page = 1
      this.getGameplanThemeUnconfiguredList()
    },
    async getGameplanThemeUnconfiguredList(){
      this.tableLoading = true
      this.queryParams.themeId = this.themeId
      const { data } = await gameplanApi.getGameplanThemeUnconfiguredList(this.queryParams);
      if (data.resultCode === "0") {
        this.prList = data.resultData?.prList || [];
        this.total = data.resultData.pageInfo.totalCounts
      }
      this.tableLoading = false
    },
    async getGamepalnBrandquery() {
      const { data } = await gameplanApi.getGamepalnBrandquery();
      if (data.resultCode === "0") {
        this.btmpBrandDTOList = data.resultData?.btmpBrandDTOList || [];
      }
    },
    resetForm() {
      this.queryParams = this.$options.data().queryParams
      this.getGameplanThemeUnconfiguredList()
    },
    async clickChange_history(row){
      const index = this.selectedPRNumberList.indexOf(row.prNumber)
      if(index===-1) {
        this.selectedPRNumberList.splice(this.selectedPRNumberList.length,0,row.prNumber)
        const data = {
          brandName:row.brandName,
          subBrandName:row.subBrandName,
          prNumber:row.prNumber,
          prName:row.prName
        }
        this.PRInfoList.splice(this.PRInfoList.length,0,data)
      }else {
        const isInit = this.initPrNumberList.indexOf(row.prNumber)!==-1
        if(isInit){
          const params = {
            themeId:this.$route.query.themeId
          }
          const { data } = await gameplanApi.gameplanThemePRIsCancel(params);
            if(data.resultCode==='0'){
              this.selectedPRNumberList.splice(index,1)
              this.PRInfoList.splice(index,1)
            }
        }
        else {
          this.selectedPRNumberList.splice(index,1)
          this.PRInfoList.splice(index,1)
        }
      }
    },
    handleSelectPR(){
      this.$emit('handleSelectPR',this.PRInfoList)
      this.dialogVisible = false
    },
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getGameplanThemeUnconfiguredList()
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  margin: 0 auto 15px;
}
::v-deep .el-dialog__body {
  overflow: auto;
  max-height: 60vh;
}
::v-deep .el-table .el-table__cell{
  padding: 10px 0;
}
::v-deep .el-input{
  width: 150px;
  margin: 0 10px 10px 0;
}
.dialog-style{
  .search-box{
    margin-bottom: 20px;
  }
}
.pagination .el-pagination {
  margin-top: 10px;
  text-align: center;
}
</style>
